<div class="text-14 d-inline-flex" [ngClass]="showIconView ? 'row-reverse' : 'row'">
	<button
		class="toggle-button cursor-pointer"
		[ngClass]="{ 'toggle-button-icon': showIconView, active: toggleStatus === toggleType.Table }"
		(click)="toggle(toggleType.Table)"
		custom-tracking
		track-event="chart-table-toggle:cta:table"
	>
		<span *ngIf="showIconView">
			<dz-icon type="list-ul"></dz-icon>
		</span>
		<span *ngIf="!showIconView" dcrHTMLKey="TABLE_VIEW_TOGGLE_TEXT">Table View</span>
	</button>
	<button
		class="toggle-button cursor-pointer"
		[ngClass]="{ 'toggle-button-icon': showIconView, active: toggleStatus === toggleType.Chart }"
		(click)="toggle(toggleType.Chart)"
		custom-tracking
		track-event="chart-table-toggle:cta:chart"
	>
		<span *ngIf="showIconView">
			<dz-icon type="chart-pie"></dz-icon>
		</span>
		<span *ngIf="!showIconView" dcrHTMLKey="CHART_VIEW_TOGGLE_TEXT">Chart View</span>
	</button>
</div>
